import getENV from "../../../../util/getENV";
import useSmartContract from "../../useSmartContract";

export default function useRemains() {
    //console.log('>>> useCatacombs')
    const { modules: { remains: { contract } } } = getENV();
    const { contract: remains } = useSmartContract(contract);
    return { remains }
}